export const iconFontAwesomeHumanitarianUsersRectangle = (
	<i className="fa-solid fa-users-rectangle"></i>
);
